export default __webpack_public_path__ + "logo_tdc_white.a161c46.svg";